import { useGetTopUser } from "@/hooks/useCommon";
import { CircleUserRound } from "lucide-react";
import { useState, useEffect } from "react";

function extractInitials(name: string): string {
    const parts = name.trim().split(/\s+/);
    const firstInitial = parts[0]?.[0] ?? '';
    const lastInitial = parts[1]?.[0] ?? '';
    return firstInitial + lastInitial;
}

export default function TopUsers() {
 
  const [users, setUsers] = useState<Array<{id: number; name: string; designation: string}>>([]);
  
  const { data } = useGetTopUser();
  
  useEffect(() => {
    if (data && Array.isArray(data)) {
      const transformedUsers = data.map((user, index) => ({
        id: user.user_id || index + 1,
        name: `${user.first_name || ''} ${user.last_name || ''}`.trim(),
        designation: user.role_name || user.RoleName || 'No Role'
      }));
      setUsers(transformedUsers);
    }
  }, [data]);

  return (
    <div className="w-full max-w-md bg-white p-1 pb-1">
      <div className="flex items-center gap-3">
        <div className="bg-[#82CA9D] p-2 rounded-md">
          <CircleUserRound className="w-5 h-5 text-white" />
        </div>
        <h1 className="text-[14px]">Top Users</h1>
      </div>

      <div className="my-6">
        {users.length > 0 ? (
          users.map(({ id, name, designation }) => (
            <div className="flex mx-2 gap-3 py-1" key={id}>
              <h1 className="font-semibold text-md bg-blue-400 rounded-full text-white w-[30px] h-[30px] flex items-center justify-center">
                {extractInitials(name)}
              </h1>
              <div className="flex flex-col items-start">
                <h1 className="font-[500] text-gray-800 text-[13px] mb-0">{name}</h1>
                <span className="text-gray-500 text-[10px]">{designation}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center text-gray-500 text-sm py-4">
            No users found
          </div>
        )}
      </div>
    </div>
  );
}
